import React from 'react';
import {LoginPageResponse} from "./models/LoginPageResponse";

const LoginPageResponseContext = React.createContext<LoginPageResponse>(null);
export default LoginPageResponseContext;
